module.exports = __webpack_public_path__ + "static/img/vux_logo.79cbb96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vux_logo.png
// module id = ge4Q
// module chunks = 1